// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Manrope_aa98a2', '__Manrope_Fallback_aa98a2'","fontStyle":"normal"},"className":"__className_aa98a2"};